import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { Breadcrumb } from '@components/breadcrumb';
import { Button } from '@components/button';
import { EmptyState } from '@components/empty-state';
import { IconButton } from '@components/icon-button';
import { IconCloseRegular } from '@components/icons/close-regular';
import { IconDownload } from '@components/icons/download';
import { IconParrot } from '@components/icons/parrot';
import { IconVisibilityShown } from '@components/icons/visibility-shown';
import { Previewer } from '@components/previewer';
import { Stack } from '@components/stack';

import { useStore } from 'models/Provider';

export const HeaderContainer = styled.div((p) => ({
  overflow: 'hidden',
  width: '100%',
  padding: p.theme.spacing.m24,
  '@media (max-width: 480px)': {
    padding: '0 10px',
  },
  color: p.theme.colors.purple100,
  display: 'flex',
  alignItems: 'center',
  borderBottom: '1px solid',
  borderColor: p.theme.colors.purpleTrans10,
  zIndex: 1000,
  backgroundColor: p.theme.colors.white100,

  '> div:nth-child(1)': {
    flexGrow: 1,
    height: '100%',
  },
}));

const Container = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  > div:nth-child(1) {
    margin-right: 24px;
    @media (max-width: 480px) {
      margin-right: 10px;
    }
  }
`;

const ParrotContainer = styled.div({
  position: 'absolute',
  right: 0,
  bottom: 0,
  transform: 'scaleX(-1)',
});

const PDFContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  paddingTop: '1.5rem',
});

function CustomFilePreviewModal({ filePath, closeModal }) {
  const { t } = useStore();

  return (
    <>
      <HeaderContainer>
        <Container>
          <Breadcrumb items={[{ label: t('integration.preview.title') }]} />
        </Container>
        <Stack space={6} orientation="horizontal">
          <Button
            variant="secondary"
            iconLeft={<IconDownload />}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              window.open(filePath, '_blank');
            }}
            text={t('application.attachment.download')}
          />
          <IconButton icon={<IconCloseRegular />} onClick={closeModal} />
        </Stack>
      </HeaderContainer>
      <PDFContainer id="CustomFileModal-container">
        <Previewer
          url={filePath}
          maxWidth={1000}
          parentId={'CustomFileModal-container'}
          fallback={
            <>
              <EmptyState
                content={t('application.files.supportedformats')}
                contentColor="purple20"
                header={t('application.files.nopreview')}
                icon={<IconVisibilityShown size={80} />}
              />
              <ParrotContainer>
                <IconParrot />
              </ParrotContainer>
            </>
          }
        />
      </PDFContainer>
    </>
  );
}

export default observer(CustomFilePreviewModal);
